export const ID25 = ()=> {
    return(
        <div>
            <h2 className="servicePage_title">УПРАВЛЕНИЕ ДОГОВОРАМИ</h2>
            <div className="content" readonly="">
                <div>
                    <h1>Планирование договорных отношений</h1>

                    <div>
                        <h2>Возможности планирования</h2>

                        <div>
                            <h3>Планирование заключаемых договоров</h3>

                            <ul>
                                <li>Заказы поставщикам</li>
                                <li>Заказы покупателей</li>
                            </ul>
                        </div>

                        <div>
                            <h3>Планирование спецификации</h3>

                            <ul>
                                <li>Планирова-ние прода-ваемых / приобретае-мых товаров, услуг, внеоборот-ных активов
                                </li>
                                <li>Планирование цены, количества, дат поставки</li>
                            </ul>
                        </div>

                        <div>
                            <h3>Планирование платежей и поступлений</h3>
                            <ul>
                                <li>Планирование простых и сложных схем расчетов. Графики платежей</li>
                                <li>Интеграция с планами подсистемы Казначей-ства</li>
                            </ul>
                        </div>

                        <div><h2>Связь с казначейством и закупками</h2></div>
                    </div>
                </div>

                <div>
                    <h2>Регистрация договора</h2>
                    <div>
                        В подсистеме «Управления договорами» имеется возможность, регистрировать договоры с поставщиками
                        и покупателями. Присутствует возможность регистрировать
                        подробные условия для каждого договора.
                    </div>
                </div>

                <div>
                    <h2>Спецификация договора</h2>
                    <div>
                        Для товарных договоров система позволяет указать предмет договора, т.е. товары и услуги, которые
                        будут поставляться в рамках данного договора. Также в
                        документе «Договор» можно указать цены по номенклатурным позициям, срок их поставки и условия
                        оплаты.
                    </div>
                </div>

                <div>
                    <h2>Условия оплаты</h2>
                    <div>
                        Подсистема позволяет настроить условия оплаты по договорам, такие, как порядок взаиморасчетов,
                        пеня за просрочки и т.д. Это могут быть как разовые
                        платежи, регулярные (за услуги по подписке или аренде и т.д.), так и платежи, определяемые
                        графиками платежей различной сложности.
                    </div>
                </div>

                <div>
                    <h2>График платежей</h2>
                    <div>
                        Для планирования оплат по договору система позволяет прикрепить к нему график платежей, который
                        может быть фиксированным, когда заранее определены даты
                        и размеры платежей, а также гибким, который, например, будет опираться на даты оформления счетов
                        фактур или других бухгалтерских документов.
                    </div>
                </div>

                <h2>Контроль исполнения договоров</h2>

                <div>
                    <h2>Контрольные и учетные функции</h2>
                    <div>Учет операций по договору, отраженных в бухгалтерском учете, происходит автоматически.</div>

                    <ul>
                        <li>Учет зарегистрированных договоров и дополнительных соглашений</li>
                        <li>Учет товарных операций по бух. учету для план-фактного анализа</li>
                        <li>Формирование бухгалтерских документов.</li>
                        <li>Контроль произведенных оплат и их своевременности</li>
                    </ul>
                </div>

                <div>
                    <h2>Регистрация дополнительных соглашений</h2>
                    <div>
                        Если в течение определенного периода договорные условия изменяются, имеется возможность не
                        править изначальную версию договора, а ввести дополнительное
                        соглашение на основании текущего договора.
                    </div>
                </div>

                <div>
                    <h2>Формирование договоров по заказам поставщикам</h2>
                    <div>
                        Имеется возможность регистрировать договоры с поставщиками товаров или услуг на основании
                        имеющих «Заказов поставщикам» при помощи специального мастера
                        по формированию договоров.
                    </div>
                </div>

                <div>
                    <h2>Заявки на расходование средств по договорам</h2>
                    <div>
                        Подсистема «Учет договоров», взаимодействует с подсистемой «Казначейство». В форме специального
                        мастера имеется возможность автоматизировать расчет
                        платежей и поступлений по договорам, с последующим формированием «Заявок на расходования
                        денежных средств».
                    </div>
                </div>

                <h2>Анализ договорных обязательств</h2>

                <div>
                    <h2>Аналитические возможности</h2>
                    <h3>Предусмотрен ряд отчетов для анализа как всего списка договоров, так и каждого в
                        отдельности</h3>

                    <ul>
                        <h3>Специализированная отчетность позволяет ответственному за ведение договоров получать данные
                            по их исполнению оперативно, не через бухгалтерию</h3>
                        <li>Формирование реестра договоров с указанными характеристиками и фильтром</li>
                        <li>Анализ исполнения договора с детализацией до номенклатуры</li>
                        <li>Анализ опера-ций по договору, задолженности, расчет предстоящих платежей</li>
                    </ul>
                </div>

                <div>
                    <h2>Исполнение договоров</h2>
                    <div>
                        Для анализа выполнения условий поставки по товарному договору предусмотрен специальный отчет
                        «Учет исполнения товарных договоров». Данный отчет
                        позволяет проанализировать номенклатурную спецификацию договора на предмет фактического
                        исполнения.
                    </div>
                </div>

                <div>
                    <h2>Отчет «Реестр договоров»</h2>
                    <div>
                        Для группового просмотра перечня договоров с возможностью вывода их условий или фильтрации по
                        ним используется отчет «Реестр договоров». В данном отчете
                        указываются основные и дополнительные параметры, которые следует вывести в реестр, а также
                        необходимые фильтры.
                    </div>
                </div>

                <div>
                    <h2>Анализ договоров</h2>
                    <div>
                        Обработка «Работа с договором» позволяет просматривать и управлять списком событий по договору,
                        а также формировать множество отчетов по договору и
                        просматривать список сформированных по нему документов, рассчитывать платежи.
                    </div>
                </div>
            </div>
        </div>
    )
}